import styles from './FeatureContents.module.css';

/**
 * @component AuditionContent
 * @description 공고 카드 내용
 */
function AuditionContent() {
  const auditions = [
    { id: 1, title: '단편영화 주연 모집', daysAgo: 1 },
    { id: 2, title: '웹드라마 조연 모집', daysAgo: 3 },
    { id: 3, title: '화장품 광고 모델', daysAgo: 7 },
  ];

  return (
    <div className={styles.auditionContent}>
      <div className={styles.auditionList}>
        {auditions.map((audition) => (
          <div key={audition.id} className={styles.auditionItem}>
            <span className={styles.auditionTitle}>{audition.title}</span>
            <span className={styles.auditionDays}>{audition.daysAgo}일 전</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AuditionContent;
